import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { orderBy } from 'lodash';
import Meaning from 'components/vocab/meaning';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

@observer
class MeaningsList extends React.Component {
  @computed get meanings() {
    if (!this.props.word || !this.props.word.meanings) return [];
    return orderBy(this.props.word.meanings, 'score', 'desc');
  }

  @computed get previewMeanings() {
    const groupedSources = new Map();
    (this.props.word?.meaningSourcePreviews || []).forEach((translationSource, index) => {
      if (!translationSource?.source) {
        return;
      }
      const meaningId = translationSource.meaningId || `preview-${index}`;
      if (!groupedSources.has(meaningId)) {
        groupedSources.set(meaningId, []);
      }
      groupedSources.get(meaningId).push(translationSource);
    });

    return Array.from(groupedSources.entries()).map(([meaningId, translationSources]) => {
      return {
        id: meaningId,
        hasSynonyms: translationSources.some(source => source.meaningHasSynonyms),
        isPreview: true,
        translationSourcesForUser: () => translationSources,
      };
    });
  }

  @computed get activeMeanings() {
    if (this.props.usePreviewMeanings) {
      return this.previewMeanings;
    }
    return this.meanings;
  }

  @computed get filteredMeanings() {
    return this.activeMeanings.filter(meaning => {
      return meaning.translationSourcesForUser(AppUI.user).length > 0;
    });
  }

  @computed get fontSize() {
    return this.props.fontSize || (AppUI.layout.isMobile ? '13px' : '16px');
  }

  @computed get lineHeight() {
    return this.props.lineHeight || (AppUI.layout.isMobile ? '17px' : '22px');
  }

  isSelectedSynonymMeaning = meaning => {
    return this.props.selectedSynonymAssociation?.meaningId &&
      String(meaning.id) === String(this.props.selectedSynonymAssociation.meaningId);
  }

  render() {
    if (!this.filteredMeanings || this.filteredMeanings.length === 0) {
      return null;
    }
    return (
      <Wrapper>
        {
          this.filteredMeanings.map((meaning, index) => (
            <Meaning
              key={meaning.id}
              meaning={meaning}
              inDeck={this.props.inDeck}
                showTopSeparator={this.props.dictionarySentences && index > 0}
                onSentencePage={this.props.onSentencePage}
                onSentencesLoaded={this.props.onSentencesLoaded}
              onPlaySentence={this.props.onPlaySentence}
              dictionarySentences={this.props.dictionarySentences}
              summaryOnly={this.props.summaryOnly}
              defaultExpanded={this.props.dictionarySentences}
              word={this.props.word}
              user={AppUI.user}
              onClickWord={this.props.onClickWord}
              hideLevels={this.props.hideLevels}
              lineHeight={this.lineHeight}
              rowMargin={this.props.rowMargin}
              synonymOverride={this.isSelectedSynonymMeaning(meaning) ? this.props.selectedSynonymAssociation.synonym : null}
            />
          ))
        }
      </Wrapper>
    );
  }
}

export default MeaningsList;
